// extracted by mini-css-extract-plugin
export default {"box":"SendSection_box__+5lND"};